import React from 'react'
import { Box, IconButton, Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  button: {
    borderRadius: '4px',
    height: 28,
    marginLeft: 12,
    '& .MuiIconButton-root':{
      padding: 0,
    },
    '& .minus': {
      cursor: 'pointer',
      fill: "rgba(223, 0, 25, 0.15) !important",
      color: '#DF0019 !important',
    },
    '& .percent': {
      FontSize: 14,
      fontWeight: 700,
    },
    '& .plus': {
      color: theme.palette.success.main,
      cursor: 'pointer',
    },
  },
  active: {

  },
})
);

const MinusIcon = (props: any): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <rect width="16" height="16" rx="8" fill="#DF0019" fillOpacity="0.15" />
      <path d="M3.33337 8.5V7.5H12.6667V8.5H3.33337Z" fill="#DF0019" />
    </svg>
  )
}
const PlusIcon = (props: any): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <rect width="16" height="16" rx="8" fill="#00D008" fillOpacity="0.15" />
      <path d="M7.50004 12.6666V8.49992H3.33337V7.49992H7.50004V3.33325H8.50004V7.49992H12.6667V8.49992H8.50004V12.6666H7.50004Z" fill="#00D008" />
    </svg>
  )
}

interface OwnProps {
  readonly onChange: (percent: number) => void;
  readonly previousPercent: number;
}

type Props = OwnProps;

const RankWeightToggle = (props: Props) => {
  const { previousPercent, onChange } = props;
  const classes = useStyles();
  const [percent, setPercent] = React.useState(0);

  const handleChange = (add: boolean) => {
    if (add && (previousPercent < 1)) {
      const newVal = percent + 5;
      setPercent(newVal);
      onChange(newVal);
    } else if (!add && (previousPercent > 0)) {
      const newVal = percent - 5;
      setPercent(newVal);
      onChange(newVal);
    }
  }

  React.useEffect(() => {
    if (previousPercent >= 0 || previousPercent <= 1) {
    setPercent(previousPercent * 100);
    }
  }, [previousPercent])

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" padding="0 2px" borderRadius="4px" width="100%" className={`${classes.button} ${percent !== 0 && classes.active}`}>
      <IconButton onClick={(e) =>{ e.stopPropagation(); handleChange(false)}}>
        <MinusIcon className='minus' />
      </IconButton>
      <div className='percent'>{percent.toFixed(0)}%</div>
      <IconButton onClick={(e) =>{ e.stopPropagation(); handleChange(true)}}>
        <PlusIcon className='plus' />
      </IconButton>
    </Box>
  )
}

export default RankWeightToggle

